module.exports = __webpack_public_path__ + "static/img/38.5c133d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/38.png
// module id = Wzkk
// module chunks = 0